import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { setUpgradeModalListener, clearUpgradeModalListener } from '../utils/upgradeModalBus';

// detail shape (from backend core/quota.py):
// {
//   error: 'quota_exceeded',
//   limit_type: 'forms' | 'fields_per_form' | 'submissions_this_month' | 'signed_docs_this_month' | 'storage',
//   current: number, limit: number,
//   plan: 'free'|'growth'|'pro'|'enterprise',
//   plan_display_name: 'Starter'|'Professional'|'Business'|'Enterprise',
//   upgrade_to: 'Professional'|'Business'|'Enterprise'|null,
//   message: string
// }
const UpgradeModalContext = createContext({ payload: null, open: () => {}, close: () => {} });

export const UpgradeModalProvider = ({ children }) => {
  const [payload, setPayload] = useState(null);

  const open = useCallback((detail) => {
    if (!detail || typeof detail !== 'object') return;
    // Defensive: Enterprise users should never see this modal — their limits are unlimited.
    if (detail.plan === 'enterprise') return;
    setPayload(detail);
  }, []);

  const close = useCallback(() => setPayload(null), []);

  useEffect(() => {
    setUpgradeModalListener(open);
    return () => clearUpgradeModalListener();
  }, [open]);

  return (
    <UpgradeModalContext.Provider value={{ payload, open, close }}>
      {children}
    </UpgradeModalContext.Provider>
  );
};

export const useUpgradeModal = () => useContext(UpgradeModalContext);
